import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
export function Newsletter() {
  const [formState, setFormState] = useState<'idle' | 'loading' | 'success'>('idle');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    jobTitle: '',
    consent: false
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('loading');
    setTimeout(() => setFormState('success'), 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };
  const inputClass = 'w-full bg-transparent border-0 border-b border-primary-dark/20 py-3 px-0 text-sm text-primary-dark placeholder:text-primary-dark/40 focus:ring-0 focus:border-primary-dark transition-colors';
  return <section id="contact" className="bg-white" data-id="element-254">
      <div className="grid lg:grid-cols-2 min-h-[700px]" data-id="element-255">
        {/* Left column — Gradient/Image */}
        <div className="relative hidden lg:block bg-gradient-to-br from-primary-dark via-[#0a2d5c] to-accent/80" data-id="element-256">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-accent/20 via-transparent to-transparent" data-id="element-257"></div>
        </div>

        {/* Right column — Form */}
        <div className="flex flex-col justify-center p-8 md:p-16 lg:p-24 bg-[#E8F0F8]" data-id="element-258">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="max-w-xl w-full mx-auto lg:mx-0" data-id="element-259">
            {formState === 'success' ? <div className="text-center lg:text-left py-16" data-id="element-260">
                <h3 className="text-4xl font-serif text-primary-dark mb-4" data-id="element-261">
                  Thank you
                </h3>
                <p className="text-lg text-primary-dark/60" data-id="element-262">
                  We've received your enquiry and will be in touch within 4
                  working hours.
                </p>
              </div> : <>
                <h2 className="text-5xl md:text-6xl font-serif text-primary-dark mb-16 leading-[1.1] tracking-tight" data-id="element-263">
                  Get your free <span className="italic" data-id="element-264">air conditioning</span>{' '}
                  consultation
                </h2>

                <form className="space-y-8" onSubmit={handleSubmit} data-id="element-265">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-266">
                    <div data-id="element-267">
                      <input id="firstName" name="firstName" type="text" placeholder="First name" required value={formData.firstName} onChange={handleChange} className={inputClass} data-id="element-268" />
                    </div>
                    <div data-id="element-269">
                      <input id="lastName" name="lastName" type="text" placeholder="Last name" required value={formData.lastName} onChange={handleChange} className={inputClass} data-id="element-270" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-271">
                    <div data-id="element-272">
                      <input id="email" name="email" type="email" placeholder="Email" required value={formData.email} onChange={handleChange} className={inputClass} data-id="element-273" />
                    </div>
                    <div data-id="element-274">
                      <input id="phone" name="phone" type="tel" placeholder="Phone" required value={formData.phone} onChange={handleChange} className={inputClass} data-id="element-275" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-276">
                    <div data-id="element-277">
                      <input id="company" name="company" type="text" placeholder="Company" required value={formData.company} onChange={handleChange} className={inputClass} data-id="element-278" />
                    </div>
                    <div data-id="element-279">
                      <input id="jobTitle" name="jobTitle" type="text" placeholder="Job title" value={formData.jobTitle} onChange={handleChange} className={inputClass} data-id="element-280" />
                    </div>
                  </div>

                  <div className="flex items-start gap-3 pt-4" data-id="element-281">
                    <input type="checkbox" id="consent" name="consent" required checked={formData.consent} onChange={handleChange} className="mt-1 rounded-sm border-primary-dark/20 text-accent focus:ring-accent" data-id="element-282" />
                    <label htmlFor="consent" className="text-sm text-primary-dark/60" data-id="element-283">
                      I have read and agree to the{' '}
                      <a href="/terms" className="text-primary-dark underline underline-offset-2" data-id="element-284">
                        Terms and Conditions.
                      </a>
                    </label>
                  </div>

                  <div className="pt-4" data-id="element-285">
                    <button type="submit" disabled={formState === 'loading'} className="bg-accent hover:bg-accent/90 disabled:opacity-70 text-white text-sm font-medium py-3.5 px-8 rounded-full transition-colors flex items-center gap-3" data-id="element-286">
                      {formState === 'loading' ? <Loader2 className="w-4 h-4 animate-spin" data-id="element-287" /> : <div className="w-2 h-2 rounded-full bg-white/40" data-id="element-288"></div>}
                      Get my free quote
                    </button>
                  </div>
                </form>
              </>}
          </motion.div>
        </div>
      </div>
    </section>;
}